var $ = global.jQuery = global.$;
var _Base = require('./_Base');

/**
 * Track CSS properties
 * @class
 * @extends _Base
 */
var StyleTrack = _Base.extend(
  /** @lends StyleTrack.prototype */
  {
  /**
   * Initialisation method
   * @private
   */
  init: function() {
    var self = this;

    for (var prop in this.options) {
      if (this.options.hasOwnProperty(prop)) {
        this.track(prop, this.options[prop]);
      }
    }

  },
  track: function(property, rule) {
    var self = this,
        split = rule.split(' '),
        watchSign = split.length === 3 ? split[0] : '+',
        watchItem = split.length === 3 ? $(split[1]).eq(0) : $(split[0]).eq(0),
        watchItemProp = property;

    switch (split.length) {
      case 2:
        watchItemProp = split[1];
        break;
      case 3:
        watchItemProp = split[2];
        break;
    }

    this.changeProperty(property, watchItem, watchItemProp, watchSign);

    $(window).on('resize orientationchange', function() {
      self.changeProperty(property, watchItem, watchItemProp, watchSign);
    });
  },
  changeProperty: function(property, watchItem, watchItemProp, watchSign) {
    var newCSS = {};
    newCSS[property] = watchSign + watchItem.css(watchItemProp);
    this.$el.css(newCSS);
  }
});

module.exports = StyleTrack;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/StyleTrack.js
// module id = 301
// module chunks = 0